import { makeAutoObservable, runInAction } from 'mobx'
import CarrierProductService from './../../shared/services/CarrierProduct.service'
import { STATE_CODES } from './ProductAvailability.constants'

class ProductAvailabilityStore {
  products = []
  lastUpdated = null
  loading = false
  error = null
  view = 'all'
  activeState = null

  constructor() {
    makeAutoObservable(this)
  }

  get total() {
    return this.products.length
  }

  get selectedProduct() {
    return this.view === 'all' ? null : this.products.find(p => `${p.id}` === `${this.view}`) || null
  }

  // { [state]: [{ product, note }] } in product sort order.
  get productsByState() {
    const byState = Object.fromEntries(STATE_CODES.map(code => [code, []]))
    this.products.forEach(product =>
      (product.states || []).forEach(({ state, note }) => {
        if (byState[state]) byState[state].push({ product, note })
      })
    )
    return byState
  }

  isAvailable = (state, product) => !!(product?.states || []).find(s => s.state === state)

  fetch = async () => {
    this.loading = true
    this.error = null

    try {
      const result = await CarrierProductService.availability()
      runInAction(() => {
        this.products = Array.isArray(result?.products) ? result.products : []
        this.lastUpdated = result?.last_updated || null
        if (this.view !== 'all' && !this.selectedProduct) this.view = 'all'
      })
    } catch (ex) {
      runInAction(() => (this.error = 'We could not load product availability. Please try again.'))
    }

    runInAction(() => (this.loading = false))
  }

  setView = view => (this.view = view ? `${view}` : 'all')

  setActiveState = state => (this.activeState = state || null)
}

export default new ProductAvailabilityStore()
